class AromaCrystalPairing extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const section = this.closest('.pairing');
    const buy = document.querySelector('[data-testid="product-information"] [id^="BuyButtons-"]');
    if (section && buy) {
      section.classList.add('pairing--inline');
      buy.after(section);
    }
    this.cards = [...this.querySelectorAll('[data-pairing-card]')];
    this.button = this.querySelector('[data-add-pair]');
    this.status = this.querySelector('[data-pairing-status]');
    this.total = this.querySelector('[data-pairing-total]');

    this.cards.forEach((card) => {
      card.addEventListener('click', () => this.selectCard(card));
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.selectCard(card);
        }
      });
    });

    this.button?.addEventListener('click', () => this.addPair());
    this.updateTotal();
  }

  selectCard(card) {
    this.cards.forEach((item) => {
      const selected = item === card;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
    this.updateTotal();
  }

  get selectedCard() {
    return this.querySelector('[data-pairing-card].is-selected') || this.cards[0];
  }

  get currentVariantId() {
    const productSection = document.querySelector('[data-testid="product-information"]');
    const selectedInput = productSection?.querySelector('form[action*="/cart/add"] [name="id"]');
    return selectedInput?.value || this.dataset.currentVariantId;
  }

  updateTotal() {
    const card = this.selectedCard;
    if (!card || !this.total) return;
    const totalCents = Number(this.dataset.currentPrice || 0) + Number(card.dataset.price || 0);
    const currency = this.dataset.currency || 'USD';
    const detail = this.querySelector('[data-selected-detail]');
    if (detail) detail.textContent = card.querySelector('div span')?.textContent || '';
    this.total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency
    }).format(totalCents / 100);
  }

  async addPair() {
    const card = this.selectedCard;
    const currentVariantId = this.currentVariantId;
    const companionVariantId = card?.dataset.variantId;
    if (!this.button || !currentVariantId || !companionVariantId) return;

    this.button.disabled = true;
    this.button.classList.add('is-loading');
    this.status.textContent = '';

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: Number(currentVariantId), quantity: 1 },
            { id: Number(companionVariantId), quantity: 1 }
          ]
        })
      });
      if (!response.ok) throw new Error('Unable to add this pairing.');
      this.status.textContent = 'Both pieces were added to your cart.';
      window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    } catch (error) {
      this.status.textContent = error.message || 'Please try again.';
    } finally {
      this.button.disabled = false;
      this.button.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('aroma-crystal-pairing')) {
  customElements.define('aroma-crystal-pairing', AromaCrystalPairing);
}
